// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".wrap[data-v-7fd72628]{margin:0 auto;width:640px;max-width:100%;text-align:center}.upload[data-v-7fd72628],.wrap[data-v-7fd72628]{aspect-ratio:16/9}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
